import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaCeseActividadDirectaByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaCeseActividadDirectaByUser = () => {
  const [loadingGetDeclaracionJuradaCeseActividadDirectaByUser, setLoadingGetDeclaracionJuradaCeseActividadDirectaByUser] = useState(false);
  const [successGetDeclaracionJuradaCeseActividadDirectaByUser, setSuccessGetDeclaracionJuradaCeseActividadDirectaByUser] = useState(false);
  const [errorGetDeclaracionJuradaCeseActividadDirectaByUser, setErrorGetDeclaracionJuradaCeseActividadDirectaByUser] = useState<any>(null);
  const [dataGetDeclaracionJuradaCeseActividadDirectaByUser, setDataDeclaracionJuradaCeseActividadDirectaByUser] = useState<any>(null);

  const [statusGetDeclaracionJuradaCeseActividadDirectaByUser, setStatusGetDeclaracionJuradaCeseActividadDirectaByUser] =
    useState<StatusGetDeclaracionJuradaCeseActividadDirectaByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaCeseActividadDirectaByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionJuradaCeseActividadDirectaByUser(true);
    setSuccessGetDeclaracionJuradaCeseActividadDirectaByUser(false);
    setErrorGetDeclaracionJuradaCeseActividadDirectaByUser(null);

    try {
      const res = await apirecord.getDeclaracionJuradaDirectaByUser(userId, expedienteId);

      setStatusGetDeclaracionJuradaCeseActividadDirectaByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetDeclaracionJuradaCeseActividadDirectaByUser(true);
      setDataDeclaracionJuradaCeseActividadDirectaByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaCeseActividadDirectaByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaCeseActividadDirectaByUser(err);
      console.error("Error en getDeclaracionJuradaCeseActividadDirectaByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionJuradaCeseActividadDirectaByUser(false);
    }
  };


  return {
    getDeclaracionJuradaCeseActividadDirectaByUser,
    loadingGetDeclaracionJuradaCeseActividadDirectaByUser,
    successGetDeclaracionJuradaCeseActividadDirectaByUser,
    errorGetDeclaracionJuradaCeseActividadDirectaByUser,
    dataGetDeclaracionJuradaCeseActividadDirectaByUser,
    statusGetDeclaracionJuradaCeseActividadDirectaByUser
  };
};

export default useGetDeclaracionJuradaCeseActividadDirectaByUser;
